<script lang="ts" setup>
import { IMarket } from "~/types/sports/market";
import { IOutcome } from "~/types/sports/outcome";

interface Props {
	outcomes: IOutcome[];
	market: IMarket;
}

const props = defineProps<Props>();

const groupedHandicapsOutcomes = computed(() => {
	return Object.groupBy(props.outcomes, (outcome) => {
		const sbvClean = outcome.sbv.replace(/[()]/g, "");
		const sbvNum = Number.parseFloat(sbvClean);
		return Number.isNaN(sbvNum) || sbvClean.includes(":") ? sbvClean : Math.abs(sbvNum);
	});
});

const showSbvOnOutcomes = (sbv: string | number, outcome: IOutcome) => {
	if (!sbv) return true;
	const cleanOutcomeSbv = outcome.sbv.replace(/[()]/g, "").trim();
	return Number.parseFloat(sbv as string) === Number.parseFloat(cleanOutcomeSbv);
};
</script>

<template>
	<div class="p-1 rounded-b-lg shadow-sm bg-light-50 gap-1 dark:bg-dark-800">
		<div v-for="(groupOutcomes, sbv, index) in groupedHandicapsOutcomes" :key="sbv">
			<div class="flex items-center p-1">
				<div class="w-[50px] text-xs mx-[20px]" :class="index === 0 ? 'mt-[18px]' : ''">
					<span v-if="market.handicap">
						{{ market.handicap }}
					</span>
					<span v-else>
						{{ sbv }}
					</span>
				</div>
				<div
					class="grid gap-2 w-full text-ellipsis"
					:class="outcomes.some((o) => o.displayName.toLowerCase().includes('draw')) ? 'grid-cols-3' : 'grid-cols-2'"
				>
					<div class="w-full grid grid-cols-1 place-items-center" v-for="outcome in groupOutcomes" :key="outcome.outcomeId">
						<!-- Headers container -->
						<div v-if="groupOutcomes && index === 0" class="text-xs text-center leading-tight w-full break-words max-w-full mb-1">
							{{ outcome.displayName }}
							<span v-if="!showSbvOnOutcomes(market.handicap, outcome)">{{ outcome.sbv }}</span>
						</div>
						<!-- Content container -->
						<div class="w-full max-w-full mt-auto">
							<slot :outcome="outcome" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
